<template>
  <div>
    <div class="error">
      {{msg}}
    </div>
  </div>
</template>
<script>
  export default {
    name: "error",
    data(){
      return{
        msg: '',
      }
    },
    created() {
      if(this.$route.query.msg){
        this.msg = this.$route.query.msg;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .error{
    width: 100%;
    height: 100%;
    background: url("../assets/404.png") no-repeat center 50px;
    text-align: center;
    padding-top: 400px;
    font-size: 30px;
  }
</style>